/* Frases útiles por situación (26c). Japonés cortés y corriente: se puede leer en voz alta (rōmaji),
   enseñar la pantalla o dejar que la lea el móvil. Las de los documentos (Yamato y hotel) se añaden detrás. */
import type { Frase } from './tipos.ts';

const f = (situacion: string, es: string, ja: string, romaji: string): Frase => ({ situacion, es, ja, romaji });

export const FRASES: Frase[] = [
  // Lo básico
  f('Lo básico', 'Hola / buenas', 'こんにちは', 'konnichiwa'),
  f('Lo básico', 'Perdone / disculpe', 'すみません', 'sumimasen'),
  f('Lo básico', 'Muchas gracias', 'ありがとうございます', 'arigatō gozaimasu'),
  f('Lo básico', 'Sí / No', 'はい / いいえ', 'hai / iie'),
  f('Lo básico', 'Un momento, por favor', 'ちょっと待ってください', 'chotto matte kudasai'),
  f('Lo básico', 'No entiendo japonés', '日本語がわかりません', 'nihongo ga wakarimasen'),
  f('Lo básico', '¿Habla inglés?', '英語は話せますか', 'eigo wa hanasemasu ka'),
  f('Lo básico', '¿Puede repetirlo más despacio?', 'もう一度ゆっくりお願いします', 'mō ichido yukkuri onegaishimasu'),
  f('Lo básico', '¿Dónde está el baño?', 'トイレはどこですか', 'toire wa doko desu ka'),
  f('Lo básico', '¿Qué es esto?', 'これは何ですか', 'kore wa nan desu ka'),
  f('Lo básico', 'Lo siento', 'ごめんなさい', 'gomen nasai'),
  // Restaurante
  f('Restaurante', 'Somos tres', '三人です', 'san-nin desu'),
  f('Restaurante', 'No tenemos reserva', '予約していません', 'yoyaku shite imasen'),
  f('Restaurante', '¿Cuánto hay que esperar?', 'どのくらい待ちますか', 'dono kurai machimasu ka'),
  f('Restaurante', '¿Tienen carta en inglés?', '英語のメニューはありますか', 'eigo no menyū wa arimasu ka'),
  f('Restaurante', '¿Qué me recomienda?', 'おすすめは何ですか', 'osusume wa nan desu ka'),
  f('Restaurante', 'Esto, por favor (señalando)', 'これをお願いします', 'kore o onegaishimasu'),
  f('Restaurante', 'Tres cervezas, por favor', 'ビールを三つください', 'bīru o mittsu kudasai'),
  f('Restaurante', 'Agua, por favor', 'お水をください', 'o-mizu o kudasai'),
  f('Restaurante', '¿Pica?', '辛いですか', 'karai desu ka'),
  f('Restaurante', 'Soy alérgico a…', '…のアレルギーがあります', '… no arerugī ga arimasu'),
  f('Restaurante', '¡Está buenísimo!', 'とてもおいしいです', 'totemo oishii desu'),
  f('Restaurante', 'Para llevar, por favor', '持ち帰りでお願いします', 'mochikaeri de onegaishimasu'),
  f('Restaurante', 'La cuenta, por favor', 'お会計をお願いします', 'o-kaikei o onegaishimasu'),
  f('Restaurante', '¿Podemos pagar por separado?', '別々に払えますか', 'betsubetsu ni haraemasu ka'),
  f('Restaurante', 'Gracias por la comida (al acabar)', 'ごちそうさまでした', 'gochisōsama deshita'),
  // Konbini y tiendas
  f('Konbini y tiendas', '¿Cuánto cuesta?', 'いくらですか', 'ikura desu ka'),
  f('Konbini y tiendas', 'Solo estoy mirando', '見ているだけです', 'mite iru dake desu'),
  f('Konbini y tiendas', '¿Lo tienen en otra talla / color?', '他のサイズ / 色はありますか', 'hoka no saizu / iro wa arimasu ka'),
  f('Konbini y tiendas', '¿Puedo probármelo?', '試着してもいいですか', 'shichaku shite mo ii desu ka'),
  f('Konbini y tiendas', 'Me lo llevo', 'これをください', 'kore o kudasai'),
  f('Konbini y tiendas', '¿Puedo pagar con tarjeta?', 'カードで払えますか', 'kādo de haraemasu ka'),
  f('Konbini y tiendas', 'Libre de impuestos, por favor', '免税でお願いします', 'menzei de onegaishimasu'),
  f('Konbini y tiendas', 'Para regalo, por favor', 'プレゼント用に包んでください', 'purezento-yō ni tsutsunde kudasai'),
  f('Konbini y tiendas', 'Caliéntelo, por favor', '温めてください', 'atatamete kudasai'),
  f('Konbini y tiendas', 'No necesito bolsa', '袋は要りません', 'fukuro wa irimasen'),
  f('Konbini y tiendas', 'El recibo, por favor', 'レシートをください', 'reshīto o kudasai'),
  // Taxi y trenes
  f('Taxi y trenes', 'A esta dirección, por favor', 'この住所までお願いします', 'kono jūsho made onegaishimasu'),
  f('Taxi y trenes', 'A la estación de…, por favor', '…駅までお願いします', '… eki made onegaishimasu'),
  f('Taxi y trenes', 'Pare aquí, por favor', 'ここで止めてください', 'koko de tomete kudasai'),
  f('Taxi y trenes', '¿Este tren va a…?', 'この電車は…に行きますか', 'kono densha wa … ni ikimasu ka'),
  f('Taxi y trenes', '¿Qué andén?', '何番線ですか', 'nanban-sen desu ka'),
  f('Taxi y trenes', '¿Dónde está la salida…?', '…出口はどこですか', '… deguchi wa doko desu ka'),
  f('Taxi y trenes', '¿Dónde hay taquillas para maletas?', 'コインロッカーはどこですか', 'koin rokkā wa doko desu ka'),
  f('Taxi y trenes', 'He perdido el tren', '電車に乗り遅れました', 'densha ni noriokuremashita'),
  // Hotel
  f('Hotel', 'Tengo una reserva a nombre de…', '…の名前で予約しています', '… no namae de yoyaku shite imasu'),
  f('Hotel', '¿Pueden guardarnos las maletas?', '荷物を預かってもらえますか', 'nimotsu o azukatte moraemasu ka'),
  f('Hotel', '¿Cuál es la contraseña del wifi?', 'Wi-Fiのパスワードは何ですか', 'waifai no pasuwādo wa nan desu ka'),
  f('Hotel', '¿A qué hora es el check-out?', 'チェックアウトは何時ですか', 'chekku-auto wa nanji desu ka'),
  f('Hotel', '¿Me da otra toalla?', 'タオルをもう一枚ください', 'taoru o mō ichimai kudasai'),
  // Coche y gasolinera
  f('Coche y gasolinera', 'Lleno de normal, por favor', 'レギュラー満タンでお願いします', 'regyurā mantan de onegaishimasu'),
  f('Coche y gasolinera', 'Lleno de súper, por favor', 'ハイオク満タンでお願いします', 'haioku mantan de onegaishimasu'),
  f('Coche y gasolinera', 'Con tarjeta, por favor', 'カードでお願いします', 'kādo de onegaishimasu'),
  f('Coche y gasolinera', '¿Dónde puedo aparcar?', 'どこに駐車できますか', 'doko ni chūsha dekimasu ka'),
  f('Coche y gasolinera', 'Hemos tenido un accidente', '事故がありました', 'jiko ga arimashita'),
  // Templos y onsen
  f('Templos y onsen', '¿Se pueden hacer fotos?', '写真を撮ってもいいですか', 'shashin o totte mo ii desu ka'),
  f('Templos y onsen', 'El sello del templo (goshuin), por favor', '御朱印をお願いします', 'goshuin o onegaishimasu'),
  f('Templos y onsen', '¿Hasta qué hora está abierto?', '何時まで開いていますか', 'nanji made aite imasu ka'),
  f('Templos y onsen', '¿Se puede entrar con tatuajes?', 'タトゥーがあっても入れますか', 'tatū ga atte mo hairemasu ka'),
  f('Templos y onsen', '¿Nos hace una foto?', '写真を撮ってもらえますか', 'shashin o totte moraemasu ka'),
  // Noche y karaoke
  f('Noche y karaoke', '¿Hay sitio para tres?', '三人入れますか', 'san-nin hairemasu ka'),
  f('Noche y karaoke', '¿Cuánto es por hora?', '一時間いくらですか', 'ichi-jikan ikura desu ka'),
  f('Noche y karaoke', 'Barra libre de bebida, por favor', '飲み放題でお願いします', 'nomihōdai de onegaishimasu'),
  f('Noche y karaoke', '¿A qué hora es la última ronda?', 'ラストオーダーは何時ですか', 'rasuto ōdā wa nanji desu ka'),
  f('Noche y karaoke', '¡Salud!', '乾杯！', 'kanpai!'),
  f('Noche y karaoke', '¿De dónde eres?', 'どこから来ましたか', 'doko kara kimashita ka'),
  f('Noche y karaoke', 'Somos de España', 'スペインから来ました', 'supein kara kimashita'),
  // Urgencias
  f('Urgencias', '¡Ayuda!', '助けて！', 'tasukete!'),
  f('Urgencias', 'Me encuentro mal', '気分が悪いです', 'kibun ga warui desu'),
  f('Urgencias', '¿Dónde hay una farmacia?', '薬局はどこですか', 'yakkyoku wa doko desu ka'),
  f('Urgencias', 'Lléveme al hospital', '病院に連れて行ってください', 'byōin ni tsurete itte kudasai'),
  f('Urgencias', 'Llame a una ambulancia (119)', '救急車を呼んでください', 'kyūkyūsha o yonde kudasai'),
  f('Urgencias', 'Llame a la policía (110)', '警察を呼んでください', 'keisatsu o yonde kudasai'),
  f('Urgencias', 'He perdido el pasaporte', 'パスポートをなくしました', 'pasupōto o nakushimashita'),
  f('Urgencias', 'Me han robado la cartera', '財布を盗まれました', 'saifu o nusumaremashita'),
  // ── Ampliación (8 oct) ──
  // Lo básico
  f('Lo básico', 'Buenos días', 'おはようございます', 'ohayō gozaimasu'),
  f('Lo básico', 'Buenas noches', 'こんばんは', 'konbanwa'),
  f('Lo básico', 'Encantado de conocerte', 'はじめまして', 'hajimemashite'),
  f('Lo básico', 'Hasta luego', 'またね', 'mata ne'),
  f('Lo básico', 'De nada', 'どういたしまして', 'dō itashimashite'),
  f('Lo básico', 'No, gracias', '結構です', 'kekkō desu'),
  f('Lo básico', 'Entendido', 'わかりました', 'wakarimashita'),
  f('Lo básico', 'No lo sé', 'わかりません', 'wakarimasen'),
  f('Lo básico', '¿Me puede ayudar?', '手伝ってもらえますか', 'tetsudatte moraemasu ka'),
  f('Lo básico', 'Números del 1 al 10', '一 二 三 四 五 六 七 八 九 十', 'ichi, ni, san, yon, go, roku, nana, hachi, kyū, jū'),
  // Orientarse
  f('Orientarse', '¿Dónde está…?', '…はどこですか', '… wa doko desu ka'),
  f('Orientarse', '¿Dónde está la estación más cercana?', '一番近い駅はどこですか', 'ichiban chikai eki wa doko desu ka'),
  f('Orientarse', '¿Cómo llego a…?', '…にはどう行けばいいですか', '… ni wa dō ikeba ii desu ka'),
  f('Orientarse', '¿Está lejos?', '遠いですか', 'tōi desu ka'),
  f('Orientarse', '¿Cuánto se tarda?', 'どのくらいかかりますか', 'dono kurai kakarimasu ka'),
  f('Orientarse', 'Siga recto', 'まっすぐ行ってください', 'massugu itte kudasai'),
  f('Orientarse', 'Gire a la derecha', '右に曲がってください', 'migi ni magatte kudasai'),
  f('Orientarse', 'Gire a la izquierda', '左に曲がってください', 'hidari ni magatte kudasai'),
  f('Orientarse', '¿Me lo enseña en el mapa?', '地図で教えてもらえますか', 'chizu de oshiete moraemasu ka'),
  f('Orientarse', 'Me he perdido', '道に迷いました', 'michi ni mayoimashita'),
  f('Orientarse', '¿Qué hora es?', '今何時ですか', 'ima nanji desu ka'),
  f('Orientarse', '¿A qué hora abre?', '何時に開きますか', 'nanji ni akimasu ka'),
  f('Orientarse', '¿A qué hora cierra?', '何時に閉まりますか', 'nanji ni shimarimasu ka'),
  // Restaurante
  f('Restaurante', 'Sin carne, por favor', '肉なしでお願いします', 'niku nashi de onegaishimasu'),
  f('Restaurante', 'Sin picante, por favor', '辛くしないでください', 'karaku shinaide kudasai'),
  f('Restaurante', '¿Qué lleva?', '何が入っていますか', 'nani ga haitte imasu ka'),
  f('Restaurante', 'Uno más, por favor', 'もう一つお願いします', 'mō hitotsu onegaishimasu'),
  f('Restaurante', 'Zona de no fumadores, por favor', '禁煙席をお願いします', 'kin\'en-seki o onegaishimasu'),
  f('Restaurante', 'Estoy lleno', 'お腹いっぱいです', 'onaka ippai desu'),
  f('Restaurante', '¿Cuánto es en total?', '全部でいくらですか', 'zenbu de ikura desu ka'),
  // Konbini y tiendas
  f('Konbini y tiendas', '¿Tienen algo más barato?', 'もっと安いものはありますか', 'motto yasui mono wa arimasu ka'),
  f('Konbini y tiendas', 'Es demasiado caro', '高すぎます', 'takasugimasu'),
  f('Konbini y tiendas', '¿Es solo en efectivo?', '現金のみですか', 'genkin nomi desu ka'),
  f('Konbini y tiendas', '¿Me lo pone en una bolsa?', '袋に入れてもらえますか', 'fukuro ni irete moraemasu ka'),
  // Taxi y trenes
  f('Taxi y trenes', 'Un billete a…, por favor', '…までの切符を一枚ください', '… made no kippu o ichimai kudasai'),
  f('Taxi y trenes', '¿Cuál es la próxima parada?', '次の駅はどこですか', 'tsugi no eki wa doko desu ka'),
  f('Taxi y trenes', '¿Dónde hago el transbordo?', 'どこで乗り換えますか', 'doko de norikaemasu ka'),
  f('Taxi y trenes', 'Me he equivocado de tren', '電車を間違えました', 'densha o machigaemashita'),
  f('Taxi y trenes', 'Recárgueme la tarjeta, por favor', 'チャージしてください', 'chāji shite kudasai'),
  // Hotel
  f('Hotel', 'El aire acondicionado no funciona', 'エアコンが動きません', 'eakon ga ugokimasen'),
  f('Hotel', '¿Me da otra manta?', '毛布をもう一枚ください', 'mōfu o mō ichimai kudasai'),
  // Coche y gasolinera
  f('Coche y gasolinera', 'Me he quedado sin gasolina', 'ガソリンがなくなりました', 'gasorin ga nakunarimashita'),
  f('Coche y gasolinera', 'Tengo un pinchazo', 'パンクしました', 'panku shimashita'),
  f('Coche y gasolinera', '¿Puede llamar a una grúa?', 'レッカー車を呼んでください', 'rekkā-sha o yonde kudasai'),
  // Urgencias
  f('Urgencias', 'Me duele la cabeza', '頭が痛いです', 'atama ga itai desu'),
  f('Urgencias', 'Me duele el estómago', 'お腹が痛いです', 'onaka ga itai desu'),
  f('Urgencias', 'Tengo fiebre', '熱があります', 'netsu ga arimasu'),
  f('Urgencias', 'Necesito un médico', '医者に診てもらいたいです', 'isha ni mite moraitai desu'),
];

/** Qué situaciones vienen a cuento en una parada, por lo que se ve en ella y por su tipo. */
export function situacionesDe(hito: string | null, tipo: string, que: string): string[] {
  if (/onsen|Shoei/i.test(que) || hito === 'onsen') return ['Templos y onsen', 'Hotel'];
  if (/karaoke|ROUND1|Noche|nocturno|Golden Gai/i.test(que) || hito === 'noche') return ['Noche y karaoke', 'Restaurante'];
  if (tipo === 'comida' || hito === 'farol') return ['Restaurante'];
  if (hito === 'coche' || /JDM|parkings|Daikoku/i.test(que)) return ['Coche y gasolinera'];
  if (tipo === 'alojamiento' || hito === 'casa' || hito === 'maleta') return ['Hotel', 'Taxi y trenes'];
  if (tipo === 'traslado' || tipo === 'vuelo' || hito === 'metro' || hito === 'tren') return ['Taxi y trenes', 'Orientarse'];
  if (/templo|torii|toriis|pagoda|kinkaku|kiyomizu|todaiji|kaminarimon|daruma|meiji|nijo|castillo/.test(hito ?? '')) return ['Templos y onsen'];
  return ['Konbini y tiendas', 'Restaurante'];
}

/** El móvil lee la frase en japonés (si tiene la voz instalada; funciona sin red en Android). */
export function leer(fr: Frase) {
  if (!('speechSynthesis' in window)) return false;
  speechSynthesis.cancel();
  const u = new SpeechSynthesisUtterance(fr.ja.replace(/…/g, ''));
  u.lang = 'ja-JP';
  u.rate = 0.9;
  const voz = speechSynthesis.getVoices().find(v => v.lang.startsWith('ja'));
  if (voz) u.voice = voz;
  speechSynthesis.speak(u);
  return true;
}
